import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form"
import { TCheckoutLayout } from "../../core/types/Checkout"
import {
  IProductPrice,
  IProductPricePaymentInstallment,
} from "../../core/types/Product"
import CheckoutPaymentsDefault from "./Layouts/LayoutDefault/CheckoutPaymentsDefault"
import { TSale } from "../../core/types/Sale"
import CheckoutPayments2 from "./Layouts/Layout2/CheckoutPayments2"
import React from "react"
import CheckoutPayments3 from "./Layouts/Layout3/CheckoutPayments3"
import CheckoutPayments4 from "./Layouts/Layout4/CheckoutPayments4"
import CheckoutPayments5 from "./Layouts/Layout5/CheckoutPayments5"
import CheckoutPayments6 from "./Layouts/Layout6/CheckoutPayments6"
import CheckoutPayments7 from "./Layouts/Layout7/CheckoutPayments7"
import CheckoutPayments8 from "./Layouts/Layout8/CheckoutPayments8"

interface ICheckoutPayments {
  layout?: TCheckoutLayout
  productPriceId: string
  loading: boolean
  loadingVoucher: boolean
  data: IProductPrice | null
  control: Control<TSale, any>
  watch: UseFormWatch<TSale>
  setValue: UseFormSetValue<TSale>
  errors: FieldErrors<TSale>
  installments?: IProductPricePaymentInstallment[]
  clearErrors: UseFormClearErrors<TSale>
  onApplyVoucher: () => void
  onRemoveVoucher: () => void
}

const CheckoutPayments = ({
  layout,
  productPriceId,
  loading,
  loadingVoucher,
  data,
  control,
  watch,
  setValue,
  errors,
  installments,
  clearErrors,
  onApplyVoucher,
  onRemoveVoucher,
}: ICheckoutPayments) => {
  if (!layout) return <></>

  const checkoutPaymentsData = {
    [TCheckoutLayout.Default]: (
      <CheckoutPaymentsDefault
        productPriceId={productPriceId}
        data={data}
        loading={loading}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        installments={installments}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout2]: (
      <CheckoutPayments2
        productPriceId={productPriceId}
        data={data}
        loading={loading}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        installments={installments}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout3]: (
      <CheckoutPayments3
        layout={layout}
        productPriceId={productPriceId}
        data={data}
        loading={loading}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        installments={installments}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout4]: (
      <CheckoutPayments4
        layout={layout}
        productPriceId={productPriceId}
        data={data}
        loading={loading}
        loadingVoucher={loadingVoucher}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        installments={installments}
        clearErrors={clearErrors}
        onApplyVoucher={onApplyVoucher}
        onRemoveVoucher={onRemoveVoucher}
      />
    ),
    [TCheckoutLayout.Layout5]: (
      <CheckoutPayments5
        layout={layout}
        productPriceId={productPriceId}
        data={data}
        loading={loading}
        loadingVoucher={loadingVoucher}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        installments={installments}
        clearErrors={clearErrors}
        onApplyVoucher={onApplyVoucher}
        onRemoveVoucher={onRemoveVoucher}
      />
    ),
    [TCheckoutLayout.Layout6]: (
      <CheckoutPayments6
        layout={layout}
        productPriceId={productPriceId}
        data={data}
        loading={loading}
        loadingVoucher={loadingVoucher}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        installments={installments}
        clearErrors={clearErrors}
        onApplyVoucher={onApplyVoucher}
        onRemoveVoucher={onRemoveVoucher}
      />
    ),
    [TCheckoutLayout.Layout7]: (
      <CheckoutPayments7
        layout={layout}
        productPriceId={productPriceId}
        data={data}
        loading={loading}
        loadingVoucher={loadingVoucher}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        installments={installments}
        clearErrors={clearErrors}
        onApplyVoucher={onApplyVoucher}
        onRemoveVoucher={onRemoveVoucher}
      />
    ),
    [TCheckoutLayout.Layout8]: (
      <CheckoutPayments8
        layout={layout}
        productPriceId={productPriceId}
        data={data}
        loading={loading}
        loadingVoucher={loadingVoucher}
        control={control}
        setValue={setValue}
        watch={watch}
        errors={errors}
        installments={installments}
        clearErrors={clearErrors}
        onApplyVoucher={onApplyVoucher}
        onRemoveVoucher={onRemoveVoucher}
      />
    ),
  }

  return checkoutPaymentsData[layout] || <></>
}

export default CheckoutPayments
